
<template>
    <div>
        <template v-for="(item, index) in menuList">
            <div style="text-align: center;" :key="index">
                <Dropdown transfer v-if="item.children.length > 0" placement="right-start" :key="index" @on-click="changeMenu">
                    <Button style="width: 60px;margin-left: -5px;padding:10px 0;" type="text">
                        <i v-if="item.iconAwesome" class="fa" :class=[item.iconAwesome] aria-hidden="true"></i>
                        <Icon v-else :color="iconColor" :type="item.iconIview" :size="18"></Icon>
                    </Button>
                    <DropdownMenu style="width: 200px;" slot="list">
                        <template v-for="(child, i) in item.children">
                            <DropdownItem :name="child.name" :key="i">
                                <i v-if="child.iconAwesome" class="fa" :class=[child.iconAwesome] aria-hidden="true"></i>
                                <Icon v-else :type="child.iconIview" :size="18"></Icon>
                                <span style="padding-left:10px;">{{ child.title }}</span>
                                <span class="sub" v-if="getCount(child.name) && getCount(child.name) != '0'">{{getCount(child.name)}}</span>
                            </DropdownItem>
                        </template>
                    </DropdownMenu>
                </Dropdown>
                <Dropdown transfer v-else placement="right-start" :key="index" @on-click="changeMenu">
                    <Button @click="changeMenu(item.name)" style="width: 60px;margin-left: -5px;padding:10px 0;" type="text">
                        <i v-if="item.iconAwesome" class="fa" :class=[item.iconAwesome] aria-hidden="true" :style="{color: iconColor}"></i>
                        <Icon v-else :color="iconColor" :type="item.iconIview" :size="18"></Icon>
                    </Button>
                    <DropdownMenu style="width: 200px;" slot="list">
                        <DropdownItem :name="item.name" :key="'d' + index">
                            <i v-if="item.iconAwesome" class="fa" :class=[item.iconAwesome] aria-hidden="true"></i>
                            <Icon v-else :type="item.iconIview" :size="18"></Icon>
                            <span style="padding-left:10px;">{{ item.title }}</span>
                            <span class="sub" v-if="getCount(item.name) && getCount(item.name) != '0'">{{getCount(item.name)}}</span>
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
        </template>
    </div>
</template>

<script>
import utils from '@/utils';
import routeAuth from "@/staticData/routeAuthEnum";
import routeCount from '@/staticData/routeCount';

export default {
    name: 'sidebarMenuShrink',
    props: {
        //菜单
        menuList: {
            type: Array
        },
        //图标颜色
        iconColor: {
            type: String,
            default: '#586E8F'
        },
        //主题
        menuTheme: {
            type: String,
            default: 'darck'
        }
    },
    computed: {
        //头部菜单所有待处理
        countWaitToHeadle(){
            return this.$store.state.countWaitToHeadle;
        }
    },
    methods: {
        //切换菜单
        changeMenu (active) {
            this.$emit('on-change', active);
        },
        //头部菜单待处理数
        getCount(routeName){
            return this.countWaitToHeadle[routeCount[routeName].apiKey];
        },
    }
};
</script>
<style lang="less" scoped>
   @import "./sidebarMenuShrink.less";
</style>



// WEBPACK FOOTER //
// src/pages/layout/business/SidebarMenuShrink.vue